<template>
  <div ref="tableContainer"></div>
</template>

<script>
import { TabulatorFull as Tabulator } from 'tabulator-tables';
import { wrapColumns } from "../../utilities/tabulatorSorter";

export default {
  props: {
    unitData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      tabulator: null,
    };
  },
  computed: {
    formattedRows() {
      const d = this.unitData;
      return [
        {
          source: "Average (Front-End)",
          avg_size: d.fe_avg_size,
          total_psf: null,
          net_psf: null,
          total_units: d.fe_total_units,
          filtered_units: d.fe_filtered_units
        },
        {
          source: "Front-End Sum Product",
          avg_size: d.weighted_average_size,
          total_psf: d.weighted_average_price,
          net_psf: d.weighted_net_psf
        },
        {
          source: "UnitMix",
          avg_size: d.unitmix_avg_size,
          total_units: d.unitmix_total_units,
          total_psf: d.unitmix_avg_psf,
          net_psf: d.unitmix_net_psf
        },
        {
          source: "Average(Back-End)",
          avg_size: d.sum_product_avg_size,
          total_psf: d.sum_product_psf,
          net_psf: null
          // net_psf: d.sum_product_total_net_psf
        },
        {
          source: "SumProduct(Back-End)",
          avg_size: d.default_field_total_avg_size,
          total_psf: d.default_field_total_avg_psf,
          net_psf: null
        },
      ];
    }
  },
  watch: {
    unitData: {
      handler() {
        this.tabulator.setData(this.formattedRows);
      },
      deep: true
    }
  },
  methods: {
    psfFormatter(cell) {
      const value = cell.getValue();
      const rowData = cell.getRow().getData();

      if (value === null || value === undefined || value === "") return "";

      let formatted = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);

      if (rowData.source === "Front-End Sum Product") {
        return `${formatted} / sqft`;
      }
      if (rowData.source === "Unitmix") {
        return `${formatted} / sqft`;
      }

      return `${formatted}`;
    }
  },
  mounted() {
    this.tabulator = new Tabulator(this.$refs.tableContainer, {
      data: this.formattedRows,
      layout: "fitDataStretch",
      columns: wrapColumns([
        { title: "Source", field: "source", fontWeight: "bold", width: 250 },
        {
          title: "Avg Size (sqft)",
          field: "avg_size",
          formatter: (cell) => {
            const value = cell.getValue();
            const rowData = cell.getRow().getData();
            if (value === null || value === undefined || value === "") return "";
            if(rowData.source === "Average (Front-End)") return `${Math.round(value).toLocaleString()} ${rowData.filtered_units ? `(${rowData.filtered_units} units)` : ''}`;
            return `${Math.round(value).toLocaleString()} ${rowData.total_units ? `(${rowData.total_units} units)` : ''}`;
          },
          formatterParams: { precision: 0, symbol: "" },
          width: 200
        },
        {
          title: "Total $PSF",
          field: "total_psf",
          formatter: "money",
          formatterParams: { symbol: "$" },
        },
        {
          title: "Net $PSF",
          field: "net_psf",
          formatter: "money",
          formatterParams: { precision: 2, symbol: "$" },
        },
      ]),
    });
  },
  beforeDestroy() {
    if (this.tabulator) {
      this.tabulator.destroy();
    }
  }
};
</script>
